import { type CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import type {
	SelectFilterMonad,
	SelectFilterState,
} from '../../../../../common/constants/filters/select-filter/types';
import { MOCK_ADDITIONAL_SITES } from '../../../../../common/constants/filters/site';
import {
	all1pProductKeys,
	all3pProductKeys,
	type ProductKeys,
} from '../../../../../common/constants/product-keys';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

export const filter: Readonly<{
	id: 'site';
	type: 'single-select' | 'multi-select';
	queryParams: {
		key: string;
		getState: (queryParams: Record<string, string[]>, cloudId: string) => SelectFilterState<'site'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (state: unknown, config: CloudConfig) => SelectFilterMonad<'site'>;
	getInitialState: (config: CloudConfig) => SelectFilterMonad<'site'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createMultiSelectFilter({
	id: 'site',
	products: [...all1pProductKeys, ...all3pProductKeys],
	alwaysVisible: false,
	universal: true,
	queryParams: {
		key: 'sites',
		fetcher: async (queryParams, config) => {
			// TODO: Replace MOCK_ADDITIONAL_SITES with collaborationContextSites from conbined config
			const options = MOCK_ADDITIONAL_SITES.filter((x) => queryParams.includes(x.cloudId)).map(
				(x) => {
					return {
						trackingKey: x.cloudId,
						value: x.cloudId,
						label: x.name,
						queryParamValue: x.cloudId,
						isSelected: true,
					};
				},
			);
			return options;
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			// TODO: Replace MOCK_ADDITIONAL_SITES with collaborationContextSites from conbined config

			return MOCK_ADDITIONAL_SITES.map((site) => ({
				trackingKey: site.cloudId,
				value: site.cloudId,
				label: site.name,
				queryParamValue: site.cloudId,
			}));
		},
	},
});
